module.exports = __webpack_public_path__ + "assets/img/28_979_big.9673879c.jpg";